import { Component } from '@angular/core';
import { FiDocumentTemplateItemViewBase } from './document-template-item-view-base';

@Component({
    selector: 'fi-document-template-item-view-site-map',
    template: `<fi-document-layout-item-site-map
        [item]="data.item"
        [templateLayoutHelper]="data.templateLayoutHelper"
        [disableEdit]="data.disableEdit"
    >
    </fi-document-layout-item-site-map>`,
    standalone: false,
})
export class FiDocumentTemplateItemViewSiteMapComponent extends FiDocumentTemplateItemViewBase {}
